import { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { MobileNavDrawer } from './MobileNavDrawer'
import { MobileWeekPage } from '../../pages/MobileWeekPage'
import { SectionPage } from '../../pages/SectionPage'
import { MobileNotesPage } from '../../pages/MobileNotesPage'
import { SettingsPage } from '../../pages/SettingsPage'
import { NoteDrawer } from '../NoteDrawer'

export function MobileShell() {
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <div
      className="mobile-shell-root"
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--color-paper)',
        overflow: 'hidden',
      }}
    >
      {/* Top app bar */}
      <div
        style={{
          height: '52px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          padding: '0 4px',
          borderBottom: '1px solid var(--color-border)',
          background: 'var(--color-paper)',
        }}
      >
        <button
          onClick={() => setDrawerOpen(true)}
          aria-label="Open menu"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--color-ink-muted)',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Menu size={20} strokeWidth={1.5} />
        </button>
      </div>

      {/* Main content */}
      <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
        <NoteDrawer />
        <Routes>
          <Route path="/" element={<Navigate to="/week" replace />} />
          <Route path="/week" element={<MobileWeekPage />} />
          <Route path="/sections/:id" element={<SectionPage />} />
          <Route path="/notes" element={<MobileNotesPage />} />
          <Route path="/notes/:id" element={<MobileNotesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </div>

      <MobileNavDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <style>{`.mobile-shell-root { height: 100vh; height: 100dvh; }`}</style>
    </div>
  )
}
